// D1: 手动触发"检查更新"的事件总线.
// SettingsPanel "关于" tab 按钮 dispatch -> UpdaterRoot 订阅 -> 立即跑 check.
// 比给 UpdaterRoot 加 Context API 更轻量, 不破坏 UpdaterRoot 现有自洽 state.

const bus = new EventTarget();

export type ManualCheckResult = "no-update" | "found" | "error" | "not-tauri";

const CHECK = "manual-check";
const RESULT = "manual-check-result";

/** SettingsPanel 调: 触发一次手动检查 */
export function requestManualCheck(): Promise<ManualCheckResult> {
  return new Promise((resolve) => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<ManualCheckResult>).detail;
      bus.removeEventListener(RESULT, handler as EventListener);
      resolve(detail);
    };
    bus.addEventListener(RESULT, handler as EventListener);
    bus.dispatchEvent(new Event(CHECK));
    // 兜底超时, 避免 UpdaterRoot 不在场 (Web 端)
    setTimeout(() => {
      bus.removeEventListener(RESULT, handler as EventListener);
      resolve("not-tauri");
    }, 8000);
  });
}

/** UpdaterRoot 订阅: 收到手动 check 请求 */
export function onManualCheck(handler: () => void): () => void {
  bus.addEventListener(CHECK, handler);
  return () => bus.removeEventListener(CHECK, handler);
}

/** UpdaterRoot 通知: check 完了, 结果回给 SettingsPanel */
export function emitManualCheckResult(result: ManualCheckResult): void {
  bus.dispatchEvent(new CustomEvent<ManualCheckResult>(RESULT, { detail: result }));
}
